import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import VHomepageUpperSlider from '../components/VHomepageUpperSlider.vue'
import VUpperSliderNavigation from '../components/VUpperSliderNavigation.vue'
import VHomepageSideVideo from '../components/VHomepageSideVideo.vue'
import VHomepageArticles from '../components/VHomepageArticles.vue'
import VFooterContactForm from '../components/VFooterContactForm.vue'
import VReferenceSlider from '../components/VReferenceSlider.vue'
import { app } from '../app'

const pinia = createPinia()

createApp({
  components: {
    VHomepageUpperSlider,
    VUpperSliderNavigation,
    VHomepageSideVideo,
    VHomepageArticles,
    VFooterContactForm,
    VReferenceSlider
  },
  extends: app
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
